var _polygon, _polygon2, _path, _g, _polygon3, _polygon4, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    points: "26.34,25.715 32.383,21.078 26.34,16.438 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.7003,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    points: "26.34,25.715  32.383,21.078 26.34,16.438 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4.1957,
    d: "M26.16,20.98c-2.402-0.046-4.719,0.879-6.43,2.563 c-1.71,1.688-2.668,3.992-2.656,6.396"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 1.5,
    y: 1.5,
    width: 45,
    height: 45
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#231F20",
    d: "M46.496,24v0.301c-0.027,1.949-0.289,3.922-0.84,5.813 c-0.512,1.891-1.297,3.711-2.32,5.395c-0.996,1.684-2.219,3.246-3.629,4.613c-1.41,1.379-2.996,2.566-4.707,3.504 c-1.711,0.98-3.547,1.711-5.465,2.18c-1.895,0.496-3.867,0.73-5.828,0.691c-1.957-0.016-3.93-0.289-5.809-0.844 c-1.89-0.523-3.71-1.297-5.394-2.316c-1.699-0.996-3.258-2.223-4.609-3.629C6.513,38.297,5.325,36.711,4.372,35 c-0.965-1.715-1.695-3.551-2.18-5.465c-0.496-1.895-0.714-3.867-0.687-5.824c0.012-1.961,0.305-3.922,0.84-5.813 c0.527-1.891,1.312-3.711,2.32-5.395c0.992-1.699,2.223-3.258,3.641-4.613c1.394-1.379,2.984-2.566,4.707-3.52 c1.699-0.965,3.55-1.695,5.453-2.18c1.902-0.48,3.863-0.719,5.835-0.688c1.961,0.012,3.922,0.301,5.813,0.855 c1.891,0.508,3.711,1.297,5.398,2.305c1.68,0.992,3.242,2.223,4.609,3.641c1.379,1.395,2.568,2.984,3.504,4.707 c0.98,1.699,1.711,3.547,2.18,5.453C46.273,20.273,46.523,22.133,46.496,24"
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    points: "26.926,27.395 34.477,21.594 26.926,15.797 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.8753,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    points: "26.926,27.395  34.477,21.594 26.926,15.797 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 5.2446,
    d: "M26.699,21.477c-3.004-0.059-5.898,1.098-8.035,3.203 c-2.141,2.109-3.335,4.988-3.319,7.992"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnClose);
export default __webpack_public_path__ + "static/media/btnClose.a5c139d672fe141892c61c84a552c676.svg";
export { ForwardRef as ReactComponent };